<template>
  <div class="import-container" style="text-align: center;">
    <h5>学科竞赛信息上传</h5>

    <!-- 学期选择 -->
    <el-select
      v-model="selectedSemesterUuid"
      placeholder="请选择学期"
      style="margin-bottom: 20px;"
    >
      <el-option
        v-for="(semester, index) in semesters"
        :key="semester.uuid"
        :label="semester.name"
        :value="semester.uuid"
      >
        <span>{{ semester.name }}</span>
        <template v-if="index === 0">
          <el-tag type="primary" style="margin-left: 10px;">当前学期</el-tag>
        </template>
      </el-option>
    </el-select>

    <!-- 上传类型单选框 -->
    <div style="margin-bottom: 20px;">
      <el-radio-group v-model="uploadType">
        <el-radio label="学生">学生</el-radio>
        <el-radio label="教师">教师</el-radio>
        <el-radio label="班级">班级</el-radio>
      </el-radio-group>
    </div>

    <!-- 新增：模板选择下拉框 -->
    <el-select
      v-model="selectedTemplateUuid"
      placeholder="请选择奖状模板"
      style="margin-bottom: 20px;"
    >
      <el-option
        v-for="template in templates"
        :key="template.uuid"
        :label="template.name"
        :value="template.uuid"
      />
    </el-select>

    <!-- 上传文件 -->
    <el-upload
      class="upload-excel"
      ref="uploadRef"
      action=""
      :http-request="handleUpload"
      :before-upload="beforeUpload"
      accept=".xlsx, .xls"
      auto-upload="false"
    >
      <template #trigger>
        <el-button type="primary">选择Excel文件</el-button>
      </template>
    </el-upload>

    <el-button
      style="margin-left: 10px;"
      type="success"
      @click="submitFile"
      :loading="loading"
    >
      上传到服务器
    </el-button>

    <!-- 错误信息对话框 -->
    <el-dialog
      v-model="errorDialogVisible"
      title="错误信息"
      width="30%"
    >
      <span>{{ errorMessage }}</span>
      <template #footer>
        <el-button @click="errorDialogVisible = false">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ElMessage } from 'element-plus'
import axios from 'axios'

export default {
  name: 'ImportPage',
  data() {
    return {
      file: null,
      loading: false,
      semesters: [],
      templates: [],              // ✅ 模板列表
      selectedSemesterUuid: '',
      selectedTemplateUuid: '',   // ✅ 选中的模板uuid
      uploadType: '学生',
      errorDialogVisible: false,
      errorMessage: '',
    }
  },
  mounted() {
    this.fetchSemesters()
    this.fetchTemplates()  // ✅ 同时加载模板列表
  },
  methods: {
    async fetchSemesters() {
      try {
        const response = await axios.get('/api/semesters')
        this.semesters = response.data.semesters
      } catch (error) {
        console.error('获取学期数据失败:', error)
        ElMessage.error('获取学期数据失败')
      }
    },
    async fetchTemplates() {
      try {
        const res = await axios.get('/api/Competition/templates')
        this.templates = res.data.templates
      } catch (error) {
        console.error('获取模板列表失败:', error)
        ElMessage.error('获取模板列表失败')
      }
    },
    beforeUpload(file) {
      this.file = file
      return false
    },
    handleUpload() {
      // 手动上传
    },
    async submitFile() {
      if (!this.file) {
        ElMessage.error('请先选择一个文件')
        return
      }
      if (!this.selectedSemesterUuid) {
        ElMessage.error('请选择一个学期')
        return
      }
      if (!this.uploadType) {
        ElMessage.error('请选择上传类型')
        return
      }
      if (!this.selectedTemplateUuid) {
        ElMessage.error('请选择一个奖状模板')
        return
      }

      this.loading = true
      const formData = new FormData()
      formData.append('file', this.file)
      formData.append('semesterUuid', this.selectedSemesterUuid)
      formData.append('uploadType', this.uploadType)
      formData.append('templateUuid', this.selectedTemplateUuid) // ✅ 新增字段传给后端

      try {
        const response = await axios.post('/api/competition/upload', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        this.loading = false
        ElMessage.success(response.data.message || '文件上传成功')
        this.file = null
        this.selectedSemesterUuid = ''
        this.selectedTemplateUuid = ''
        this.uploadType = 'student'
        this.$refs.uploadRef.clearFiles()
      } catch (error) {
        this.loading = false
        this.errorMessage = error.response?.data?.error || '文件上传失败'
        this.errorDialogVisible = true
      }
    },
  },
}
</script>
